<div>
  <div class="mt-4">
    <div class=" row mb-2" *ngIf="!isLoadingInquiries">
      <div class="col-md-8">
        <div class="h-100 d-flex align-items-center ">
          <h5 class="bold">Inquiries</h5>
          <button 
            class="btn btn-primary btn-sm ml-3" 
            data-toggle="modal"
            data-target="#addInquiryModal"
          >
            Record Inquiry
          </button>
        </div>
      </div> 
      <div class="col-md-2" *ngIf="inquiriesData?.length>0 && countryName==='India'">
        <select 
          name="filterStates" 
          id="states2"
          style="width: 100%; cursor: pointer;"
          class="px-2 py-1"
          (change)="onInqStateOptionSelected($event)"
          ng-model="selection"
          ng-init="selection ='chosenState'"
        >
          <option *ngFor="let state of inqStates">{{state}}</option>
        </select>
      </div>
      <div class="col-md-2" *ngIf="inquiriesData?.length>0 && countryName==='Uganda'">
        <select 
          name="filterDistricts" 
          id="ugdistrict"
          style="width: 100%; cursor: pointer;"
          class="px-2 py-1"
          (change)="onDistrictOptionSelected($event)"
          ng-model="selection"
          ng-init="selection ='chosenDistrict'"
        >
          <option *ngFor="let district of inqDistricts">{{district}}</option>
        </select>
      </div>
      <div class="col" *ngIf="inquiriesData?.length>0">
        <input 
          type="text" 
          placeholder="Search"
          name="searchInquiry"
          (keyup)="filterInquiries($event)"
          class="px-2 py-1"
        >
      </div>
    </div>
    <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingInquiries">
      <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
    </div>
    <div *ngIf="!isLoadingInquiries">
      <div *ngIf="inquiriesData?.length===0" style="text-align: center;">
        No inquiries added yet...
      </div>
      <div *ngIf="inquiriesData?.length>0">
        <table class="table table-bordered table-primary">
          <thead>
            <tr class="text-uppercase">
              <th>#</th>
              <th scope="col">Farmer name</th>
              <th scope="col">Inquiry</th>
              <th scope="col">Answer</th>
              <th scope="col">Contact</th>
              <th scope="col">Answered</th>
              <th scope="col">Handled by</th>
              <th scope="col">Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of inquiriesDataFilter | paginate: { id: 'paginate1', itemsPerPage: count, currentPage: inqPage };
            let i = index">
              <td>{{ (inqPage - 1) * count + i + 1 }}</td>
              <td>{{row.farmer_name}}</td>
              <td>{{row.question}}</td>
              <td>{{row.answer}}</td>
              <td>{{row.contact}}</td>
              <td 
                [className]="row.answered_status.toLowerCase()"
              >
                <span class="dot mr-2"></span>
                {{row.answered_status}}
              </td>
              <td>{{row.handled_by}}</td>
              <td>{{row.inquiry_date | date: 'dd/MM/yyyy'}}</td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    ACTION
                  </button>
                  <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                    <button
                      class="dropdown-item suspend"
                      data-toggle="modal"
                      data-target="#editInquiryModal"
                      (click)="setSingleInquiriesViewData(row)"
                    >
                      View details
                    </button>
                    <button
                      class="dropdown-item suspend text-danger"
                      data-toggle="modal"
                      data-target="#deleteInquiryModal"
                      (click)="setSingleInquiriesViewData(row)"
                    >
                      Delete Inquiry
                    </button>
                    <button
                      *ngIf="checkInquiryStatus('No',row)"
                      class="dropdown-item suspend"
                      data-toggle="modal"
                      data-target="#resolveInquiryModal"
                      (click)="setSingleInquiriesViewData(row)"
                    >
                      Resolve
                    </button>
                    <button
                      *ngIf="checkInquiryStatus('Yes',row)"
                      class="dropdown-item suspend text-success"
                    >
                      Resolved
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!isLoadingInquiries">
          <nav>
            <pagination-controls id="paginate1" (pageChange)="inqPage = $event"></pagination-controls>
          </nav>
        </div>
      </div>
    </div>
  </div>

    <!-- Add Inquiry Modal -->
    <div class="modal fade" id="addInquiryModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true" style="overflow: auto;">
      <div class="modal-dialog modal-lg" role="document" (click)="onClickOutside()">
        <div class="modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;">Add Inquiry</h5>
            <button 
              type="button" 
              class="close close-btn"  
              aria-hidden="true" 
              data-dismiss="modal"
              (click)="closeModal()"
              >&times;</button>
          </div>
          <div class="modal-body">
            <form
              class="form"
              #addInquiriesForm="ngForm"
              (ngSubmit)="addInquiries(addInquiriesForm.value)"
              id="addInquiryForm"
            >
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="farmerName">Farmer Name</label>
                    <br>
                    <p-autoComplete 
                      name="farmer"
                      #farmer="ngModel"
                      [(ngModel)]="model.farmer"
                      [suggestions]="filteredFarmers"
                      field="name"
                      size="43" 
                      (completeMethod)="filterFarmers($event)"
                      (onSelect)="handleSelectedFarmer($event)"
                      placeholder='Enter or search and select name...'
                      delay="1000"
                      completeOnFocus="true"
                      itemSize="25"
                      [minLength]="1"
                      required
                    >
                      <ng-template let-farmer pTemplate="item">
                        {{farmer.name}}
                      </ng-template>
                    </p-autoComplete>
                    <div
                    *ngIf="farmer.touched && !farmer.valid"
                    class="text-danger error_message"
                    >
                      <span *ngIf="farmer.hasError('required')">
                        Please the name is required
                      </span>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="countryName==='India'">
                    <label for="state">State</label>
                    <select 
                      name="state"
                      #state="ngModel"
                      [(ngModel)]="selectedFarmer.state"
                      style="width: 100%; cursor: pointer;"
                      class="form-control"
                      required
                    >
                      <option hidden disabled selected value> -- select a state -- </option>
                      <option *ngFor="let state of indiaStates">{{state}}</option>
                    </select>
                    <div
                    *ngIf="state.touched && !state.valid"
                    class="text-danger error_message"
                    >
                      <span *ngIf="state.hasError('required')">
                        Please the state is required
                      </span>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="countryName==='Uganda'">
                    <label for="state">District</label>
                    <select 
                      name="district"
                      #district="ngModel"
                      [(ngModel)]="selectedFarmer.district"
                      style="width: 100%; cursor: pointer;"
                      class="form-control"
                      required
                    >
                      <option hidden disabled selected value> -- select a district -- </option>
                      <option *ngFor="let district of ugandaDistricts">{{district}}</option>
                    </select>
                    <div
                    *ngIf="district.touched && !district.valid"
                    class="text-danger error_message"
                    >
                      <span *ngIf="district.hasError('required')">
                        Please the district is required
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="contact">Contact</label>
                      <input
                        type="tel"
                        class="form-control"
                        id="contact"
                        name="contact"
                        #contact="ngModel"
                        [(ngModel)]="selectedFarmer.phone"
                        pattern="^\+?\d{1,15}$"
                        required
                      >
                      <div
                      *ngIf="contact.touched && !contact.valid"
                      class="text-danger error_message"
                      >
                        <span *ngIf="contact.hasError('required')">
                          Please the contact is required
                        </span>
                        <span *ngIf="contact.hasError('pattern')">
                          Please enter a valid phone number, 
                          not beyond 10 digits and without spaces, 
                          in the format XXX... or +XXX...
                        </span>
                      </div>
                  </div>
                  <div class="form-group">
                    <label for="contact">Date</label>
                    <input 
                      [owlDateTime]="dt1"
                      [owlDateTimeTrigger]="dt1"
                      placeholder="Enter date..."
                      class="form-control"
                      name="inquiry_date"
                      #inquiry_date="ngModel"
                      [(ngModel)]="model.inquiry_date"
                      required
                    >
                    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                    <div
                    *ngIf="inquiry_date.touched && !inquiry_date.valid"
                    class="text-danger error_message"
                    >
                      <span *ngIf="inquiry_date.hasError('required')">
                        Please enter the date
                      </span>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="question">Question</label>
                      <textarea 
                        class="form-control" 
                        id="question" 
                        rows="8"
                        name="question"
                        #question="ngModel"
                        [(ngModel)]="model.question"
                      ></textarea>
                  </div>
                </div>
                <div class="col border-left">
                  <div class="form-group">
                    <label for="answer">Answer</label>
                      <textarea 
                        class="form-control" 
                        id="answer"
                        rows="18"
                        name="answer"
                        #answer="ngModel"
                        [(ngModel)]="model.answer"
                      ></textarea>
                  </div>

                  <div class="form-group">
                    <label for="handled_by">Handled By</label>
                      <input
                        type="text"
                        class="form-control"
                        name="handled_by"
                        #handled_by="ngModel"
                        [(ngModel)]="model.handled_by"
                      >
                  </div>
                </div>
              </div>
              <br>
              <div class="modal-footer no-border">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal()">Cancel</button>
                <button
                  type="submit"
                  class="btn btn-primary float-right"
                  [disabled]="!addInquiriesForm.form.valid"
                >
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Add Inquiry
                </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Inquiries modal-->
    <div class="modal fade" id="deleteInquiryModal" tabindex="-1" role="dialog" aria-labelledby="deleteInquiryModal"
     aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" *ngIf="singleInquiriesViewData">
          <div class="modal-header no-border">
            <h5 class="modal-title text-primary">Delete Inquiry</h5>
            <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
             </button>
          </div>
          <div class="modal-body">
            This inquiry will be deleted permanently.
            Do you wish to continue?
          </div>
          <div class="modal-footer no-border">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="button" 
              class="btn btn-primary" 
              (click)="deleteInquiry(singleInquiriesViewData.id)"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Yes, Delete
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

  <!-- Edit Inquiry Modal -->
  <div class="modal fade" id="editInquiryModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content container-fluid" *ngIf="singleInquiriesViewData">
        <div class="modal-header">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Inquiry Details</h5>
          <button 
            type="button" 
            class="close close-btn"  
            aria-hidden="true" 
            data-dismiss="modal"
            (click)="closeEditModal()"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            *ngIf="singleInquiriesViewData"
            class="form"
            #editInquiriesForm="ngForm"
            (ngSubmit)="editInquiries(editInquiriesForm.value)"
            id="editInquiryForm"
          >
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label for="farmerName">Farmer Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="farmerName"
                      name="farmer_name"
                      #farmer_name="ngModel"
                      [(ngModel)]="singleInquiriesViewData.farmer_name"
                      required
                    >
                    <div
                      *ngIf="farmer_name.touched && !farmer_name.valid"
                      class="text-danger error_message"
                      >
                        <span *ngIf="farmer_name.hasError('required')">
                          Please the name is required
                        </span>
                      </div>
                </div>
                <div class="form-group" *ngIf="countryName==='India'">
                  <label for="state">State</label>
                  <input
                    type="text"
                    class="form-control"
                    name="state"
                    #state="ngModel"
                    [(ngModel)]="singleInquiriesViewData.state"
                    required
                  >
                  <div
                    *ngIf="state.touched && !state.valid"
                    class="text-danger error_message"
                    >
                      <span *ngIf="state.hasError('required')">
                        Please the state is required
                      </span>
                    </div>
                </div>
                <div class="form-group" *ngIf="countryName==='Uganda'">
                  <label for="district">District</label>
                  <input
                    type="text"
                    class="form-control"
                    name="district"
                    #district="ngModel"
                    [(ngModel)]="singleInquiriesViewData.district"
                    required
                  >
                  <div
                    *ngIf="district.touched && !district.valid"
                    class="text-danger error_message"
                    >
                      <span *ngIf="district.hasError('required')">
                        Please the district is required
                      </span>
                    </div>
                </div>
                <div class="form-group">
                  <label for="contact">Contact</label>
                    <input
                      type="tel"
                      class="form-control"
                      id="contact"
                      name="contact"
                      #contact="ngModel"
                      [(ngModel)]="singleInquiriesViewData.contact"
                      required
                    >
                    <div
                      *ngIf="contact.touched && !contact.valid"
                      class="text-danger error_message"
                      >
                        <span *ngIf="contact.hasError('required')">
                          Please the contact is required
                        </span>
                        <span *ngIf="contact.hasError('pattern')">
                          Please enter a valid phone number, 
                          not beyond 10 digits and without spaces, 
                          in the format XXX... or +XXX...
                        </span>
                      </div>
                </div>
                <div class="form-group">
                  <label for="contact">Date</label>
                    <input
                      [owlDateTime]="dt2"
                      [owlDateTimeTrigger]="dt2"
                      placeholder="Enter date..."
                      class="form-control"
                      name="inquiry_date"
                      #inquiry_date="ngModel"
                      [(ngModel)]="singleInquiriesViewData.inquiry_date"
                      required
                    >
                    <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                    <div
                      *ngIf="inquiry_date.touched && !inquiry_date.valid"
                      class="text-danger error_message"
                      >
                        <span *ngIf="inquiry_date.hasError('required')">
                          Please enter the date
                        </span>
                      </div>
                </div>

                <div class="form-group">
                  <label for="question">Question</label>
                    <textarea 
                      class="form-control" 
                      id="question" 
                      rows="8"
                      name="question"
                      #question="ngModel"
                      [(ngModel)]="singleInquiriesViewData.question"
                    ></textarea>
                </div>
              </div>
              <div class="col border-left">
                <div class="form-group">
                  <label for="answer">Answer</label>
                    <textarea 
                      class="form-control" 
                      id="answer"
                      rows="18"
                      name="answer"
                      #answer="ngModel"
                      [(ngModel)]="singleInquiriesViewData.answer"
                    ></textarea>
                </div>

                <div class="form-group">
                  <label for="handled_by">Handled By</label>
                    <input
                      type="text"
                      class="form-control"
                      name="handled_by"
                      #handled_by="ngModel"
                      [(ngModel)]="singleInquiriesViewData.handled_by"
                    >
                </div>
              </div>
            </div>
            <br>
            <div class="modal-footer">
                <button
                  type="submit"
                  class="btn btn-primary float-right"
                  [disabled]="!editInquiriesForm.form.valid"
                >
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Save Changes
                </span>
                </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Resolve Inquiry modal-->
  <div class="modal fade" id="resolveInquiryModal" tabindex="-1" role="dialog" aria-labelledby="resolveInquiryModal"
  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content" *ngIf="singleInquiriesViewData">
       <div class="modal-header no-border">
         <h5 class="modal-title text-primary">Resolve Question</h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
        Are you sure you want to resolve this question?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button 
           type="button"
           class="btn btn-primary"
           (click)="resolveInquiry(singleInquiriesViewData.id)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
             Yes, Resolve
           </span>
         </button>
       </div>
     </div>
    </div>
  </div>
</div>
